module.exports = __webpack_public_path__ + "media/images/img/tag_company/mbsd_tag-0041ffb26abeb037cf031209d01fea56.png";